// @ts-nocheck

const basketSetMPCard = (state, action) => {
  const { familyId, index } = action.payload;

  return {
    ...state,
    monopolyCard: {
      familyId,
      index,
    },
  };
};

export default basketSetMPCard;
